export class AudioManager {
  constructor() {
    this.ctx = null;
    this.initialized = false;
  }

  // Initialize AudioContext on first user interaction
  init() {
    if (!this.initialized) {
      this.ctx = new (window.AudioContext || window.webkitAudioContext)();
      this.initialized = true;
    }
  }

  // Simple tone generator using Web Audio API
  playTone(freq, duration = 0.2, type = 'square', volume = 0.1) {
    if (!this.ctx) return; // Skip if not initialized
    if (this.ctx.state === 'suspended') {
      this.ctx.resume();
    }
    const osc = this.ctx.createOscillator();
    const gain = this.ctx.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    gain.gain.value = volume;
    osc.connect(gain);
    gain.connect(this.ctx.destination);
    osc.start();
    osc.stop(this.ctx.currentTime + duration);
  }

  // Play a short sequence of tones for musical effects
  playSequence(notes, duration = 0.15, volume = 0.1, type = 'square') {
    if (!this.ctx) return; // Skip if not initialized
    if (this.ctx.state === 'suspended') {
      this.ctx.resume();
    }
    let t = this.ctx.currentTime;
    for (const n of notes) {
      const osc = this.ctx.createOscillator();
      const gain = this.ctx.createGain();
      osc.type = type;
      osc.frequency.value = n;
      gain.gain.setValueAtTime(volume, t);
      gain.gain.linearRampToValueAtTime(0, t + duration);
      osc.connect(gain);
      gain.connect(this.ctx.destination);
      osc.start(t);
      osc.stop(t + duration);
      t += duration * 0.8;
    }
  }

  // Event wrappers for common game sounds
  playSpawn() {
    this.playTone(523, 0.1, 'square', 0.08); // C5
  }

  playFire() {
    this.playTone(880, 0.05, 'square', 0.05); // A5
  }

  playHit() {
    this.playTone(196, 0.1, 'square', 0.1); // G3
  }

  playKill() {
    this.playSequence([392, 523, 659], 0.12, 0.08); // G4->C5->E5
  }

  playLevelUp() {
    this.playSequence([523, 659, 784], 0.12, 0.08); // C5->E5->G5
  }

  playBaseSpawn() {
    this.playSequence([261, 392, 523], 0.15, 0.1); // C4->G4->C5
  }

  playBerserkerBaseDestroy() {
    // Epic sound for berserker destroying a base
    this.playSequence([110, 165, 220, 330, 440], 0.2, 0.15, 'sawtooth'); // A2->E3->A3->E4->A4
  }
}

export const audioManager = new AudioManager();
